export enum PaymentbillingPath  {
PAYMENT_MAIN_PATH = 'billings/payments',
PAYMENT_ESTATE_PATH = 'billings/payments/estate',
PAYMENT_VERIFICATION_PATH = 'billings/payments/verification'
}